'use client';

import { token } from '@terra/ui-styled-system';
import { Badge } from '../../../components/badge';
import { Spinner } from '../../../components/spinner';
import { useTranslations } from 'next-intl';
import type { InternalNetworkCredentialVerificationStatus } from './internal-credentials.model';

const STATUS_LABEL_KEYS = {
  NOT_VERIFIED: 'notVerified',
  VERIFYING: 'verifying',
  VERIFIED: 'verified',
  FAILED: 'verificationFailed',
} as const satisfies Record<
  InternalNetworkCredentialVerificationStatus,
  string
>;

const STATUS_BACKGROUNDS: Record<
  InternalNetworkCredentialVerificationStatus,
  string | undefined
> = {
  NOT_VERIFIED: undefined,
  VERIFYING: token('colors.bg.accent.light'),
  VERIFIED: token('colors.bg.neutral.success'),
  FAILED: token('colors.bg.neutral.error'),
};

type InternalNetworkCredentialVerificationBadgeProps = {
  status: InternalNetworkCredentialVerificationStatus;
};

export const InternalNetworkCredentialVerificationBadge = ({
  status,
}: InternalNetworkCredentialVerificationBadgeProps) => {
  const t = useTranslations('designSystem.credentials.card');
  const isVerifying = status === 'VERIFYING';

  return (
    <Badge
      size="sm"
      bg={STATUS_BACKGROUNDS[status]}
      variant="fill"
      color={isVerifying ? token('colors.fg.accent.muted') : undefined}
      leadingContent={
        isVerifying ? (
          <Spinner size="sm" borderColor="bg.accent.default" />
        ) : undefined
      }
    >
      {t(STATUS_LABEL_KEYS[status])}
    </Badge>
  );
};
